import { ERRORTYPE } from 'utils/validation';
import { DocumentsFormData, DocumentsErrorData } from './types';

const validation = ({ documentsAcceptance }: DocumentsFormData): DocumentsErrorData => {
  return !documentsAcceptance ? { documentsAcceptance: ERRORTYPE.REQUIRED } : {};
};

export default validation;
